import { render, staticRenderFns } from "./new_directory_modal.vue?vue&type=template&id=0bc6fc6e"
import script from "./new_directory_modal.vue?vue&type=script&lang=js"
export * from "./new_directory_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports